import { roundPrice } from '../index'

const PAYMENT_PROVIDER_METHODS = ['EC_TERMINAL', 'TAP_TO_PAY', 'QR_CODE']

export const getPrepaidPayments = (order) => (order?.payments ?? [])
	.filter(payment => payment?.payed && payment?.status !== 'CANCELED' && !PAYMENT_PROVIDER_METHODS.includes(payment?.method))

export const getPrepaidSum = (order) => roundPrice(getPrepaidPayments(order).reduce((sum, payment) => sum + payment.total, 0))
